import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { tableMapper } from "layout/settings/acronymIgnoreList/tableMapper";
import SubHeader from "layout/settings/acronymIgnoreList/SubHeader";
import Header from "layout/settings/acronymIgnoreList/Header";
import Table, {
  styledTable,
} from "@visiblethread/react-components/dist/components/Table";
import { tableVariants } from "@visiblethread/react-components/dist/components/Table/constants";
import { fetchAcronymIgnoreList } from "slices/settings/actions/acronymIgnoreList";
import {
  addNewTerm,
  deleteTerm,
  setEditedList,
} from "slices/settings/slices/acronymIgnoreSlice";
import { containsRowWithErrors } from "layout/settings/tableHelpers";
import RegexPopup from "layout/settings/acronymIgnoreList/RegexPopup";
import { arraysEqualWithOrder } from "utils";
import { setActiveTab } from "slices/settings/slices/activeTabSlice";
import { selectAcronymIgnore } from "slices/settings/selectors";

const AcronymIgnoreList = () => {
  const dispatch = useDispatch();
  const { editMode, ignoreList, selectedIndex, ignoreListItem, showRegex } =
    useSelector(selectAcronymIgnore);

  const [rows, setRows] = useState([]);
  const [selectedRowIndex, setSelectedRowIndex] = useState(0);
  const [selectedColumnIndex, setSelectedColumnIndex] = useState(0);
  const [hasErrors, setHasErrors] = useState(false);

  const { getHeader, getRows, getState } = tableMapper(
    dispatch,
    editMode,
    addNewTerm,
    deleteTerm
  );

  useEffect(() => {
    dispatch(fetchAcronymIgnoreList());
    dispatch(setActiveTab(4));
  }, []);

  useEffect(() => {
    setSelectedRowIndex(0);
    setSelectedColumnIndex(0);
  }, [editMode]);

  useEffect(() => {
    setRows(getRows(ignoreList));
  }, [ignoreList, editMode]);

  useEffect(() => {
    if (rows.length > 1 && !arraysEqualWithOrder(rows, getRows(ignoreList))) {
      dispatch(setEditedList(getState(rows)));
    }
    setHasErrors(containsRowWithErrors(rows));
  }, [rows]);

  useEffect(() => {
    setSelectedRowIndex(selectedIndex);
  }, [selectedIndex]);

  return (
    <>
      <Header hasErrors={hasErrors} />
      <SubHeader selectedRowIndex={selectedRowIndex} />
      <Table
        id="acronym_ignore_list-table"
        dataTestId="acronym_ignore_list-table"
        content={{ header: getHeader(), rows, setRows }}
        config={{
          variant: tableVariants.plain,
          editable: editMode,
          draggable: editMode,
          table: styledTable.excel,
          resizable: true,
          persistSettings: true,
          selectedRowIndex,
          selectedColumnIndex,
          setSelectedRowIndex,
          setSelectedColumnIndex,
        }}
      />
      {showRegex && <RegexPopup ignoreListItem={ignoreListItem} />}
    </>
  );
};

export default AcronymIgnoreList;
